export function requestSuccess(turmas) {
  return {
    type: '@turmas/REQUEST_SUCCESS',
    payload: { turmas },
  };
}
